<template>
	<div class="footerdiv">
		<el-checkbox v-model="reminduser" v-if="showremind">提醒微信用户</el-checkbox>
		<el-checkbox  v-model="remindleader" v-if="showremind">提醒上级用户</el-checkbox>
	    <el-button v-for="(b,index) in footerbtn" :key="index" size="mini" :type="b.type" @click.native="handle(b.event)" class="footerhandler">{{b.name}}</el-button>
		<el-button size="mini" @click="cancel">取 消</el-button>
	</div>
</template>
<script>
export default {
	props: {
		//底部操作按钮数组，name--按钮名称 event--按钮事件 type--按钮类型，例如：primary/danger/warning
		footerbtn: { 
			type: Array,
			default: []
		},
		//操作栏应用在哪个功能模块，比如group--表示应用在添加分组功能的地方,方便调用父页面方法时对应参数
		winname:{
			type:String,
			default:''
		},
		//操作权限编号，用于判断是否显示发送提醒的勾选框
		permissionid:{
			type:String,
			default:''
		}
	},
	data() {
		return {
			showremind:true,
			reminduser:false,
			remindleader:false
		};
	},
	mounted() {
		if(this.permissionid==''){
			this.showremind=false;
		}else{
			this.getremindset();
		}
	},
	methods: {
		//获取提醒设置
		getremindset(){
			var that=this;
			if(localStorage.getItem('wxenabled')){
				this.$apipost.get.GetRemindSet({permessionid:this.permessionid}).then(res => {
					res.list.forEach(e=>{
						if(e.m_type=='提醒微信用户'){
							that.reminduser=Parser.Boolean(m.m_enabled.toString().toLowerCase());
						}
						else if(e.m_type=='提醒上级用户'){
							that.remindleader=Parser.Boolean(m.m_enabled.toString().toLowerCase());
						}
					});
					
				});
			}else{
				this.showremind=false;
			}
		},
		//操作列按钮事件
		handle(event) {
			this.$emit('footerhandle', 
			{ 
				winname: this.winname,
				funname:event
			});
		},
		//关闭窗口
		cancel() {
			this.$emit('closedialog', {
				winname: this.winname
			});
		}
	}
};
</script>
<style>
</style>
